import {
  IRephraseState, Prompt, PromptParameter, TemplateParameters,
} from '..'
  
export interface IRephraseGetters {

  /**
   * Gets the prompts list.
   * @param state Current state.
   * @returns The prompts list.
   */
  prompts (state: IRephraseState): Prompt[] | undefined

  /**
   * Gets the prompt parameters list.
   * @param state Current state.
   * @returns The prompt parameters list.
   */
  promptParameters (state: IRephraseState): PromptParameter[] | undefined

  /**
   * Gets the template parameters list.
   * @param state Current state.
   * @returns The prompt parameters list.
   */
  templateParameters (state: IRephraseState): TemplateParameters[] | undefined

  /**
   * Gets the langs list.
   * @param state Current state.
   * @returns The langs list.
   */
  langs (state: IRephraseState): string[] | undefined

  /**
   * Gets the current modified prompt.
   * @param state Current state.
   * @returns The current prompt.
   */
  currentPromptId (state: IRephraseState): string | undefined
}

export const RephraseGetters: IRephraseGetters = {

  prompts (state: IRephraseState): Prompt[] {
    return state.prompts
  },

  promptParameters (state: IRephraseState): PromptParameter[] {
    return state.promptParameters
  },

  templateParameters (state: IRephraseState): TemplateParameters[] {
    return state.templateParameters
  },

  langs (state: IRephraseState): string[] {
    return state.langs
  },

  currentPromptId (state: IRephraseState): string {
    return state.currentPromptId
  }
}
